module.exports = __webpack_public_path__ + "polaris@2x.78fe5012ba83d554949a.png";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/vendors/css/forms/icheck/polaris/polaris@2x.png
// module id = ../../../../../src/assets/vendors/css/forms/icheck/polaris/polaris@2x.png
// module chunks = styles